import { useBranding } from "../contexts/BrandingContext";

/** Ping default logo — loaded only after API confirms BluTec platform (never on partner domains). */
const PLATFORM_LOGO = `${process.env.PUBLIC_URL || ""}/favicon.ico`;

/**
 * White-label aware logo — nothing until API completes; Ping only on BluTec platform after API.
 */
export function BrandLogo({ className = "", alt, title, ...props }) {
  const brand = useBranding();
  const {
    showBrandSkeleton,
    isWhiteLabel,
    isBrandingReady,
    isDefaultHost,
    logo_url: logoUrl,
    name,
  } = brand;

  if (showBrandSkeleton || !isBrandingReady) {
    return (
      <div
        className={`brand-logo-skeleton ${className}`.trim()}
        aria-hidden="true"
        title={title}
      />
    );
  }

  if (isWhiteLabel) {
    if (!logoUrl) {
      return (
        <div
          className={`brand-logo-skeleton ${className}`.trim()}
          aria-hidden="true"
          title={title || name}
        />
      );
    }
    return (
      <img
        src={logoUrl}
        alt={alt ?? name}
        className={className}
        title={title ?? name}
        {...props}
      />
    );
  }

  if (isDefaultHost) {
    const src = logoUrl || PLATFORM_LOGO;
    return (
      <img
        src={src}
        alt={alt ?? (name || "Blutec Ping")}
        className={className}
        title={title ?? name}
        {...props}
      />
    );
  }

  return null;
}

export default BrandLogo;
